import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import { IManagementStore } from "@src/Stores/Management/types";
import OrganisationsContent from "./OrganisationsContent/OrganisationsContent";
import { Values } from "@src/Tools/Values";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
class ManageOrganisations extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await this.props.management.getOrganisations();
      this.isLoading = false;
      document.title = Values.getLocalizationValue("organisations");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <OrganisationsContent />}</div>;
  }
}

export default ManageOrganisations;
